import React from 'react';

import Interest from './components/Interests';
import OutputStatus from './components/OutputStatus';
import Platforms from './components/Platforms';
import Services from './components/Services';
import useSetting from './useSetting';
import ManageVideoCategories from '../../role/Admin/ScreenRecorder/ManageVideoCategories';

export default function Setting() {
  const { keys, handleSelect, selectedKey } = useSetting();
  return (
    <div className="m-5 mt-0">
      <div className="mb-4 flex justify-between items-center"></div>
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Left side title */}
        <div className="lg:w-1/4 w-full overflow-y-auto h-[82vh]">
          <div className="space-y-2">
            {keys.map((keys: any) => (
              <button
                key={keys}
                onClick={() => handleSelect(keys)}
                className={`w-full px-4 py-2 text-left border border-gray-300 rounded-md hover:bg-gray-100 focus:ring focus:ring-blue-200 `}
              >
                {keys}
              </button>
            ))}
          </div>
        </div>
        <div className="w-full h-[75vh] overflow-auto border border-gray-300 rounded-md shadow-sm">
          <div className=" w-full">
            {selectedKey === "platform" ? (
              <Platforms />
            ) : selectedKey === "interest" ? (
              <Interest />
            ) : selectedKey === "services" ? (
              <Services />
            ) : selectedKey === "outputStatus" ? (
              <OutputStatus />
            ) : selectedKey === "videoCategories" ? (
              <ManageVideoCategories />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
